import Vue from 'vue';
import Vuex from 'vuex';
import axiosAuth from './axios-auth';
import route from './router/index'

Vue.use(Vuex)

export default new Vuex.Store({


    state: {
        user: null,
        // jwt: null,
        // username: null,
        // user: null,
        invalidPassword: false
    },
    mutations: {
        authUser (state, userData) {
            state.user = userData;
            state.invalidPassword = false
        },
        storeUser (state, user) {
            state.user = user;
        },
        logout(state) {
            state.user = null;
            state.invalidPassword = null;
        },
        invalidPassword(state) {
            state.invalidPassword = true;
        }
    },
    actions: {
        login({commit}, authData) {
            axiosAuth.post('/login',authData)
                .then(response => {
                    console.log(response)
                    commit('authUser', response.data);
                    localStorage.setItem('user',JSON.stringify(response.data));
                    route.push("/");
                })
                .catch(error => {
                    commit('invalidPassword');
                    console.log(error);
                });
        },
        tryAutoLogin({commit}) {
            let user = localStorage.getItem('user');
            //const authUser = {jwt: jwt, username: ""};          
            if (user && JSON.parse(user).expirationDate > new Date().getTime()) {
                commit('authUser', JSON.parse(user));
            } else {
                route.push("/");
            }
        },
        logout({commit}){
            commit('logout');
            localStorage.removeItem('user');
            console.log('route', route)
            if (route.history.current.fullPath != '/login') {
                route.push("/login");
            }
        },
        storeUser({commit}) {
            console.log(commit);
        },
        fetchUer({commit}) {
            //axios.get...
            console.log(commit);
        }
    },
    getters: {
        user(state) {
            return state.user;
        },
        invalidPassword(state) {
            return state.invalidPassword;
        }
    }


})